import m from 'mithril';
import MessageProvider from '../../../MessageProvider';
import { BookingSummaryCard, GuestInfo } from '../../../Models';
import BookingSessionSummaryComponent from '../../common/guestinfo/BookingSessionSummaryComponent';
import GuestDetailsForm from '../../common/guestinfo/GuestDetailsForm';
import LoadingIndicator from '../../common/LoadingIndicator';
import { Dialog, SvgIcon } from '../../common/MaterialDesignComponents';

interface Attrs {    
    messageProvider: MessageProvider;
    bookingSummaryCard:BookingSummaryCard;
    presetCountryCode: string|null;
    restartUrl?: string,
    attemptingBackNav: boolean;
    onSubmit: (guestInfo: GuestInfo, totalAdults:number, totalChildren:number, specialRequest:string) => void;
    onChangeAttemptingBackNav: () => void;
    onBackPressed: () => void;
}

export default function GuestDetailsFormPage(): m.Component<Attrs> {
    let submissionInProgress = false;
    let totalAdultsOfRoomsSelected = 0;

    return {
        oncreate(vnode){
            window.scrollTo(0, 0);
        },
        oninit(vnode) {
            vnode.attrs.bookingSummaryCard.roomTypeSelections.forEach(roomSelection => totalAdultsOfRoomsSelected += roomSelection.numberOfAdults);
        },
        view(vnode) {
            const { messageProvider, bookingSummaryCard, presetCountryCode, restartUrl, attemptingBackNav, onSubmit, onChangeAttemptingBackNav, onBackPressed} = vnode.attrs;

            return m("div", 
                m("div.row", [
                    m("div.col-7 pr-4 py-4 border-right mb-4", 
                        (!submissionInProgress)?                        
                        m(GuestDetailsForm, { 
                            presetCountryCode: presetCountryCode,               
                            messageProvider : messageProvider,
                            totalAdultsOfRoomsSelected: totalAdultsOfRoomsSelected,
                            totalChildrenOfRoomsSelected: bookingSummaryCard.roomTypeSelections.length,
                            restartUrl: restartUrl,
                            onSubmit: (guestInfo: GuestInfo, totalAdults:number, totalChildren:number, specialRequest:string) => {
                                submissionInProgress = true;
                                onSubmit(guestInfo, totalAdults, totalChildren, specialRequest);
                            }                
                        }):
                        m(LoadingIndicator, {
                            message: "Submitting guest details..."
                        }) 
                    ),
                    m("div.col-5 pt-4 pl-4", 
                        m(BookingSessionSummaryComponent, {
                            isDesktop: true,
                            bookingSummaryCard: bookingSummaryCard,
                            messageProvider: messageProvider,
                            collapsible: false,
                        })
                    )
                ]),
                m(Dialog, {
                    isOpen: attemptingBackNav,
                    onClose : () => {
                        onChangeAttemptingBackNav();
                    },
                    actionItems : [
                        {
                            label: "Cancel",
                            onclick: () => {
                                onChangeAttemptingBackNav();
                            }
                        },
                        {
                            label: "Ok",
                            onclick: () => {
                                onBackPressed();
                            }
                        }
                    ]
                }, [
                    m("div.text-center", 
                        m(SvgIcon, {
                        iconType: "warning",
                        colorScheme: "warning",
                        sizeScheme: "largest"
                        })
                    ),
                    m("div", {class:"mb-1"}, messageProvider.get("warning_cancel_guest_state"))
                ])           
            );
        }
    }
}